export class PromotionDetailsDto {
    public sitePriceId: string;
    public name: string;
    public description: string;
    public originalAmount: number;
    public discountAmount: number;
    public discountPercentage: number;
    public startDate: Date | null;
    public endDate: Date | null;

    constructor(item?: Partial<PromotionDetailsDto>) {
        const source = item ?? {};

        this.sitePriceId = source.sitePriceId ?? '';
        this.name = source.name ?? '';
        this.description = source.description ?? '';
        this.originalAmount = source.originalAmount ?? 0;
        this.discountAmount = source.discountAmount ?? 0;
        this.discountPercentage = source.discountPercentage ?? 0;
        this.startDate = source.startDate ? new Date(source.startDate) : null;
        this.endDate = source.endDate ? new Date(source.endDate) : null;
    }
}